import GeorgeMartins from '@components/profile/george_martins';

const GeorgeMartinsComponent = () => {
  return <GeorgeMartins />;
};

export default GeorgeMartinsComponent;
